<template>
    <div class="login-auth">
        <p class="text-muted text-center mb-5">Sign in into your account</p>

        <div class="loginMsg"></div>

        <form>
            <div class="form-group">
                <label>Email Address</label>
                <input type="email" name="email" class="form-control" placeholder="name@address.com"
                    v-model="loginData.email" v-validate="'required|email'"
                >
                <span class="text-danger">{{ errors.first('email') }}</span>
            </div>

            <div class="form-group">
                <div class="row">
                    <div class="col">
                        <label>Password</label>
                    </div>
                    <div class="col-auto">

                        <a href="javascript:void(0)" class="form-text small text-muted" v-on:click="forgotPassword()">
                            Forgot password?
                        </a>

                    </div>
                </div>

                <input type="password" name="password" class="form-control" placeholder="Enter your password"
                    v-model="loginData.password" v-validate="'required'"
                >
                <span class="text-danger">{{ errors.first('password') }}</span>
            </div>

            <button class="btn btn-lg btn-block btn-primary mb-3" v-on:click.prevent="login($event)">
                Sign in
            </button>

        </form>
    </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
    components: {},
    name: "Login",
    data() {
        return {
            loginData: {
                email: "",
                password: ""
            }
        };
    },
    methods: {
        ...mapMutations(["CHANGE_LOGIN_STATE"]),
        forgotPassword() {
            this.CHANGE_LOGIN_STATE(false);
        },
        //Login function
        login(e) {
            var self = this;
            var btn = e.currentTarget;
            var sve = document.querySelector(".s-v-e");
            if (sve) sve.remove();
            $(".loginMsg").html("");

            var login_data = {
                email: this.loginData.email,
                password: this.loginData.password
            };

            this.$validator.validateAll().then(result => {
                if (result) {
                    $.ajax({
                        type: "POST",
                        url: APIURL + "admin/login",
                        data: login_data,
                        dataType: "JSON",
                        beforeSend() {
                            btn.classList.add("is-loading");
                            btn.classList.add("is-loading-sm");
                        },
                        success(response) {
                            btn.classList.remove("is-loading");
                            btn.classList.remove("is-loading-sm");

                            if (response.status == 200) {
                                self.loginData.email = "";
                                self.loginData.password = "";
                                self.$validator.reset();

                                let userData = {
                                    firstname: response.data.firstname,
                                    lastname: response.data.lastname,
                                    email: response.data.email,
                                    adminid: response.data.mask,
                                    profileImg: "",
                                    access_token: response.data.access_token
                                };

                                self.$store.commit("SET_USER_DATA", userData);

                                window.localStorage.setItem(
                                    "authUser",
                                    JSON.stringify(userData)
                                );
                                self.$router.push("/dashboard/practice-areas");
                            } else {
                                if (response.status == 403) {
                                    $.each(response.errors, function(k, v) {
                                        $("#" + k).after(v);
                                        self.loginData.password = "";
                                    });
                                } else {
                                    var html = `<div class="alert alert-danger alert-dismissible fade show mb-3" role="alert">
                                                    ${response.msg}
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                                        <span aria-hidden="true">×</span>
                                                    </button>
                                                </div>`;
                                    $(".loginMsg").html(html);
                                    self.loginData.password = "";
                                }
                            }
                        }
                    });
                }
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/auth/Login.vue